import { FiltersContextProvider } from '@openx/components-filters/lib/context/FiltersContext.tsx';
import { Table, TableName } from '@openx/components-table/Table.tsx';
import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import type { CuratedDealBuyerDiscountApi } from '../../../types/curatedDealBuyerDiscount.ts';
import { CuratedDealBuyerDiscountDetailsDrawer } from './CuratedDealBuyerDiscountDetailsDrawer.tsx';
import { CuratedDealBuyerDiscountsTopBar } from './CuratedDealBuyerDiscountsTopBar.tsx';
import { useCuratedDealBuyerDiscountChipFilters } from './hooks/useCuratedDealBuyerDiscountChipFilters.ts';
import { useCuratedDealBuyerDiscountColumns } from './hooks/useCuratedDealBuyerDiscountColumns.tsx';
import { useCuratedDealBuyerDiscountListFetch } from './hooks/useCuratedDealBuyerDiscountListFetch.tsx';
import { useCuratedDealBuyerDiscountRowActions } from './hooks/useCuratedDealBuyerDiscountRowActions.ts';

export const CuratedDealBuyerDiscountsList = () => {
  const { criteria, curatedDealBuyerDiscounts, handleCriteriaChange, handleFiltersChange, loading } =
    useCuratedDealBuyerDiscountListFetch();

  const filtersConfig = useCuratedDealBuyerDiscountChipFilters(criteria, handleFiltersChange);
  const columns = useCuratedDealBuyerDiscountColumns(criteria.filters?.phrase);
  const rowActions = useCuratedDealBuyerDiscountRowActions();
  const navigate = useNavigate();

  const handleRowClick = useCallback(
    ({ uid }: CuratedDealBuyerDiscountApi) => {
      navigate(`/discounts/${uid}/details`);
    },
    [navigate]
  );

  return (
    <FiltersContextProvider config={filtersConfig}>
      <CuratedDealBuyerDiscountsTopBar />

      <Table
        columns={columns}
        criteria={criteria}
        data={curatedDealBuyerDiscounts}
        loading={loading}
        name={TableName.CURATED_DEAL_BUYER_DISCOUNTS}
        onCriteriaChange={handleCriteriaChange}
        onRowClick={handleRowClick}
        rowActions={rowActions}
      />

      <CuratedDealBuyerDiscountDetailsDrawer />
    </FiltersContextProvider>
  );
};
